///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild } from '@angular/core';
import { KbNumericInputBaseComponent } from './../numeric-input.base.component';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
    selector: 'kb-numeric-text-box',
    templateUrl: './numeric-text-box.component.html',
})
export class KbNumericTextBoxComponent extends KbNumericInputBaseComponent {
    @ViewChild('numericInput')
    public numericInput: NumericTextBoxComponent;
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/numeric-text-box/numeric-text-box.component.ts